import BaseTibbit from '@appblocks/codegeneration/Tibbits/_BaseTibbit';
import Tibbits from '@appblocks/codegeneration/Tibbits/index';
import {
    CodeBlock, BlockType, SettingType, Setting, IOMode,
} from '@appblocks/codegeneration/types';
import IOTibbit from '@appblocks/codegeneration/Tibbits/_IOTibbit';

export default class Tibbit_59 extends IOTibbit {
    constructor() {
        super();
        this.id = 'tibbit_59';
        this.name = 'Tibbit 59';
        this.lines = 2;
        this.mode = IOMode.OUTPUT;
        this.initLines();
    }
}
